import { useCallback } from 'react';

import { formatRoute } from 'src/lib/routing';
import { preparePlatformUrl } from 'src/lib/url';
import { ROUTES, ROUTE_PARAMS } from 'src/routes';
import { useCreateCopyScoringModelPopup } from 'src/services/popup';
import { useIsApplicationModeInfinity } from 'src/services';
import { usePopupActions } from '../../store';
import { usePopupCloseHandlerContextValue } from '../../services';

const formatModelsLink = () => {
  const route = formatRoute(ROUTES.CUSTOM_SCORING_MODELS, {
    [ROUTE_PARAMS.createNewScoringModel]: true,
  });
  return preparePlatformUrl(route);
};

export const useHandlers = (onCreationPopupClose, generationTool) => {
  const isAppModeInfinity = useIsApplicationModeInfinity();

  const popupActions = usePopupActions();
  const openCreateCopyScoringModelPopup = useCreateCopyScoringModelPopup();
  const popupCloseHandler = usePopupCloseHandlerContextValue();

  const handleChange = useCallback(
    (event) => {
      popupActions.selectCustomModel(event.target.value);
    },
    [popupActions]
  );

  const handleOpenCreateCopyScoringModelPopup = useCallback(async () => {
    if (isAppModeInfinity) {
      const link = formatModelsLink();
      window.open(link, '_blank');
      popupCloseHandler();
      return;
    }

    const id = await openCreateCopyScoringModelPopup();
    await onCreationPopupClose(generationTool);

    popupActions.selectCustomModel(id);
  }, [
    isAppModeInfinity,
    openCreateCopyScoringModelPopup,
    onCreationPopupClose,
    generationTool,
    popupActions,
    popupCloseHandler,
  ]);

  return {
    handleChange,
    handleOpenCreateCopyScoringModelPopup,
  };
};
